// extracted by mini-css-extract-plugin
module.exports = {"point_transfer_header":"ManagePointTransfer_point_transfer_header__1zhl2","background_div":"ManagePointTransfer_background_div__2-nHZ"};